<template>
  <b-modal :active.sync="isModalActive" :width="640" scroll="keep">
    <div class="border border-blue-light rounded shadow bg-white">
      <form @submit.prevent="saveExtraField" class="w-full">
        <header class="font-thin uppercase text-blue-light modal-card-head"
        >Añadir / editar campo adicional</header>

        <div class="modal-card-body ">
            <div class="border-grey-light border-b border-dashed mb-3">
              <div class="w-full inline-flex pb-3">
                <label form="reference_code" class="md:w-1/3">{{ $t('reference_code')}}</label>
                <v-input
                  v-model="form.code"
                  title="reference_code"
                  required="true"
                  name="code"
                  placeholder="reference_code"
                  class="md:w-2/3"
                  maxlength="100"
                />
              </div>

              <div class="w-full inline-flex pb-3">
                <label form="name" class="md:w-1/3">{{ $t('name')}}</label>
                <v-input
                  v-model="form.name"
                  title="name"
                  required="true"
                  name="name"
                  placeholder="name"
                  class="md:w-2/3"
                  maxlength="100"
                />
              </div>

              <div class="w-full inline-flex pb-3">
                <label form="type" class="md:w-1/3">{{ $t('type')}}</label>
                <b-select v-model="form.field_type" :placeholder="$t('select')" class="md:w-2/3" expanded>
                    <option v-for="option in options" :value="option.value" :key="'type_'+option.value">
                      {{ option.text }}
                    </option>
                </b-select>
              </div>

              <div class="w-full inline-flex">
                <label form="order_column" class="md:w-1/3">{{ $t('order')}}</label>
                <b-input type="number"
                  min="0"
                  max="100"
                  v-model="form.order_column"
                  class="md:w-2/3">
                </b-input>
              </div>

            </div>
            <div 
              class="w-full border border-blue-lighter rounded flex items-center p-2 bg-blue-lightest mb-1" 
              v-if="form.field_type == 0 && create_new"
              >

                <span class="inline-flex ml-2">
                  <input v-model="selectValueCode" type="text" :placeholder="$t('code')" class="input mr-2">
                  <input v-model="selectValueName" type="text" :placeholder="$t('name')" class="input mr-2">
                </span>
                <b-tooltip :label="$t('add_generic')" class="">
                  <button class="btn btn-green items-center"  type="button" @click="addValue()">
                    <i class="fas fa-plus"></i>
                  </button>
                </b-tooltip>


              <!-- </b-tooltip> -->
            </div>
            <!-- aqui van la lista de values -->
            <div
              v-for="(values, index) in selectValues"
              :key="index"
              class="w-full border border-blue-lighter rounded flex-col items-center p-2 bg-blue-lightest mb-1"
            >
              <div class="flex items-center">
                <span v-if="values.code">{{ values.code }} - </span>
                {{ values.name }}
              </div>

              <b-tooltip :label="$t('remove')" position="is-left" type="is-danger">
                <div @click="deleteValue(index, values.name)" class="flex cursor-pointer text-red">
                  <b-icon pack="fas" icon="trash-alt"/>
                </div>
              </b-tooltip>
            </div>

        </div>
        <footer class="modal-card-foot">
          <div class="w-full inline-flex justify-end">
            <button class="btn btn-blue" nativeType="submit">{{$t('save')}}</button>
          </div>
        </footer>
      </form>
    </div>
  </b-modal>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Form from "vform";

export default {
  name: "custom-field-modal",

  components: {},
  computed: {
    ...mapGetters({
      company: "app/company",
    })
  },

  data: () => ({
    isModalActive: false,
    data: null,
    isSelectType: false,

    selectValues: [], // para el select > tendra los valores de code, name
    selectValueCode: "", // para el select > tendra el valor de code
    selectValueName: "", // para el select > tendra el valor de name

    create_new: true,

    form: {
      code: "",
      name: "",
      field_type: "",
      order_column: "",
      values: [],
    },
    options: [
      { value: 0, text: 'select' },
      { value: 1, text: 'input' },
      { value: 2, text: 'calendar' },
      { value: 3, text: 'checkbox' },
    ]
  }),

  watch: {
    'form.field_type': function (newVal) {
      if (newVal == 0) {
        // si es select 
        this.isSelectType = true;
      } else {
        this.isSelectType = false;
        this.selectValues = [];
        this.selectValueCode = "";
        this.selectValueName = "";
      }
    }
  },

  methods: {
    async saveExtraField() {
      let url = "/api/v2/company/"+this.company.id+"/customfield";

      if( this.data.id > 0 )
        url = "/api/v2/customfield/" + this.data.id;

      axios({
        method: "post",
        url: url,
        data: this.form
      })
        .then(response => {
          this.$toast.open({
            message: this.$t("save_successful"),
            type: "is-success",
            position: "is-top-right"
          });

          this.hide();
          this.$emit("reload-custom-fields");
        })
        .catch(error => {
          //Se produjo un error
          this.isLoading = false;
          if (error.response && error.response.status === 422) {
            //extraemos el primer error de validación
            error.error_msg =
              error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ][0];
          }

          // Mostramos el error
          this.$toast.open({
            message: error.error_msg || this.$t("save_error"),
            type: "is-danger",
            position: "is-top-right"
          });
        }).finally(() => {
          this.isLoading = false;
          this.isModalActive = false;
          this.form.code = "";
          this.form.name = "";
          this.form.field_type = "";
          this.form.order_column = "";
          this.selectValues = [];
          this.selectValueCode = "";
          this.selectValueName = "";
          this.form.values = [];
          this.isSelectType = false;

        })
        ;
    },
    addValue() {
      if (this.selectValueCode == "" || this.selectValueName == "") {
        this.$toast.open({
          message: this.$t("select_code_name"),
          type: "is-danger",
          position: "is-top-right"
        });
        return;
      }

      let value = {
        code: this.selectValueCode,
        name: this.selectValueName
      };

      this.form.values.push(value);
      this.selectValues.push(value);
      this.selectValueCode = "";
      this.selectValueName = "";
    },
    deleteValue(index, valueName) {
      let self = this;
      this.$dialog.confirm({
        title: this.$t('delete'),
        message: this.$t('delete_generic', [valueName]),
        confirmText: this.$t('delete'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async () => {
          self.form.values.splice(index, 1);
          self.selectValues.splice(index, 1);
        }
      })
    },

    show(data) {
      this.data = data;
      this.form.code = data.code;
      this.form.name = data.name;
      this.form.field_type = data.field_type;
      this.form.order_column = data.order_column;
      this.form.is_automatic = data.is_automatic;
      this.isModalActive = true;
      this.create_new = data.create_new ? true : false;
    },

    hide() {
      this.data = null;
      this.isModalActive = false;
      this.form.code = "";
      this.form.name = "";
      this.field_type = "";
      this.order_column = "";
      this.is_automatic = false;
    }
  }
};
</script>
<style scoped>
/* Oculta los botones para aumentar los inputs numéricos */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}
</style>
